import { render, staticRenderFns } from "./GeneralKasbonView.vue?vue&type=template&id=04a3815a"
import script from "./GeneralKasbonView.vue?vue&type=script&lang=js"
export * from "./GeneralKasbonView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports